import React from 'react';

import { Box, Button, Stack } from '@mui/material';

/** A screen that stops the app, and the way out of it.
 *
 * Eko has three of these — Visma not connected, the roles call failed, no role in this company —
 * and each used to be a paragraph of text and nothing else. The navigation bar, which carries the
 * only log-out button, renders on the working path alone, so anyone who landed here could not log
 * out, could not log in as somebody else and could not try again: the only exit was to type
 * /auth/logout into the address bar. Every blocked state goes through here now, so none of them
 * can be built without an exit again.
 *
 * Logging out is always offered because it is the one action that cannot itself be blocked — it
 * only clears the session, and needs neither Visma nor a role.
 */
export default function Blocked({children, onRetry, onLogOut}: {
        children: React.ReactNode,
        // Omitted when trying again cannot help — nothing on this screen changes by asking twice.
        onRetry?: () => void,
        onLogOut: () => void}) {

    return (
        <Box sx={{ p: 2, maxWidth: '40em' }}>
            {children}
            <Stack direction="row" spacing={1} sx={{ mt: 3 }}>
                {onRetry && <Button variant="contained" onClick={onRetry}>Försök igen</Button>}
                <Button variant="outlined" onClick={onLogOut}>Logga ut</Button>
            </Stack>
        </Box>
    )
}
